"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserIcon = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledSvg = styled_components_1.default.svg `
    color: ${({ theme }) => theme.colorIconHeader};
`;
const UserIcon = () => (react_1.default.createElement(StyledSvg, { viewBox: "0 0 32 32", xmlSpace: "preserve" },
    react_1.default.createElement("g", { fill: "currentColor" },
        react_1.default.createElement("path", { d: "M16 1c8.3 0 15 6.7 15 15s-6.7 15-15 15S1 24.3 1 16 7.7 1 16 1m0-1C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0z" }),
        react_1.default.createElement("path", { d: "M23 21.2v1.7c-1.9.1-12 .1-13.9.1-.1-.6-.1-1.2-.1-1.8.1-3.1 2.4-5.7 5.5-6.2-1.3-.7-2.1-2-2.1-3.5v-.3C12.2 9 13.9 7.1 16 7c2.1.1 3.7 2 3.6 4.1v.3c0 1.5-.8 2.8-2.1 3.6 2.9.7 5.5 3 5.5 6.2z", fillRule: "evenodd", clipRule: "evenodd" }))));
exports.UserIcon = UserIcon;
//# sourceMappingURL=UserIcon.js.map